/* global Sys, NetEntExtend, Services */
Sys.ns("NetEntExtend.API");

/**
 * Slots specific additions / overrides for Restricted NetEntExtend Calls.
 *
 * @class NetEntExtend.API.Restricted.Calls
 * @extends NetEntExtend.API.Calls.Restricted
 */
Sys.apply(NetEntExtend.API.Restricted.Calls, {

    startSpin: Sys.applyPropertiesIf({
        platforms: ["desktop"],
        isAvailable: function() {
            return !(Services.gameRound.isRoundActive() || Services.dialog.isShowing()) &&
                (Services.bet.getBetCash() <= Services.money.getBalanceCash() || Services.freeRounds.isActive());
        },
        func: function() {
            Services.gameRound.start();

            this.success.apply(this, arguments);
        }
    }, NetEntExtend.API.BaseCall),

    startQuickSpin: Sys.applyPropertiesIf({
        platforms: ["desktop"],
        isAvailable: function() {
            return !(Services.gameRound.isRoundActive() || Services.dialog.isShowing()) &&
                Services.gameSettings.isSettingEnabled("quickSpin") &&
                (Services.bet.getBetCash() <= Services.money.getBalanceCash() || Services.freeRounds.isActive());
        },
        func: function() {
            var originalValue = Services.gameSettings.getSetting("quickSpin");

            Services.gameSettings.setSetting({
                id: "quickSpin",
                value: true
            });

            // Restore original value once game round is complete.
            Services.gameRound.on("ended", function() {
                Services.gameSettings.setSetting({
                    id: "quickSpin",
                    value: originalValue
                });
            }, true);

            Services.gameRound.start();

            this.success.apply(this, arguments);
        }
    }, NetEntExtend.API.BaseCall),

    /**
     * Sets the bet level to max and starts a spin.
     *
     * @memberof NetEntExtend.API.Restricted.Calls
     */
    maxBetSpin: Sys.applyPropertiesIf({
        platforms: ["desktop"],
        func: function() {
            var originalValue = Services.bet.getBetLevel(),
                maxBetLevel = Math.max.apply(null, Services.bet.getBetLevels());

            Services.bet.setBetLevel(maxBetLevel);

            // Restore original value once game round is complete.
            Services.gameRound.on("ended", function() {
                Services.bet.setBetLevel(originalValue);
            }, true);

            Services.gameRound.start();

            this.success.apply(this, arguments);
        }
    }, NetEntExtend.API.BaseCall),

    /**
     * Toggles the feature splash.
     *
     * @memberof NetEntExtend.API.Restricted.Calls
     */
    featurePreview: Sys.applyPropertiesIf({
        platforms: ["desktop"],
        func: function() {
            // intentionally left blank
            this.success.apply(this, arguments);
        }
    }, NetEntExtend.API.BaseCall)
});
